<div class="check-out-table-container">
  @if (loading) {
    <div class="flex justify-center items-center h-64">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (!loading) {
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
      <p-table
        (onLazyLoad)="onPageChange($event)"
        [currentPageReportTemplate]="'checkOutTable.pagination' | translate"
        [first]="first"
        [lazy]="true"
        [loading]="loading"
        [paginatorDropdownAppendTo]="'body'"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [rows]="rows"
        [showCurrentPageReport]="true"
        [totalRecords]="totalRecords"
        [value]="checkOuts"
        stripedRows
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'checkOutTable.columns.reservation' | translate }}</th>
            <th>{{ 'checkOutTable.columns.guest' | translate }}</th>
            <th>{{ 'checkOutTable.columns.room' | translate }}</th>
            <th>{{ 'checkOutTable.columns.checkIn' | translate }}</th>
            <th>{{ 'checkOutTable.columns.checkOut' | translate }}</th>
            <th>{{ 'checkOutTable.columns.nights' | translate }}</th>
            <th>{{ 'checkOutTable.columns.total' | translate }}</th>
            <th>{{ 'checkOutTable.columns.payment' | translate }}</th>
            <th>{{ 'checkOutTable.columns.status' | translate }}</th>
            <th>{{ 'checkOutTable.columns.actions' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template let-entry pTemplate="body">
          <tr>
            <td>
              <span class="font-semibold text-primary-600">{{ entry.reservationNumber }}</span>
            </td>
            <td>
              <span class="font-semibold">{{ entry.guestName }}</span>
            </td>
            <td>
              <span class="font-semibold">{{ entry.roomNumber }}</span>
            </td>
            <td>
              <span>{{ entry.checkInDate }}</span>
            </td>
            <td>
              <div>
                <div>{{ entry.checkOutDate }}</div>
                <div class="text-xs text-gray-500">{{ entry.checkOutTime }}</div>
              </div>
            </td>
            <td>
              <span>{{ 'checkOutTable.nightsValue' | translate: { count: entry.nights } }}</span>
            </td>
            <td>
              <span class="font-semibold">{{ formatCurrency(entry.totalCharges) }}</span>
            </td>
            <td>
              <p-tag
                [severity]="getPaymentStatusSeverity(entry.paymentStatus)"
                [value]="entry.paymentStatus"
              ></p-tag>
            </td>
            <td>
              <p-tag [severity]="getStatusSeverity(entry.status)" [value]="entry.status"></p-tag>
            </td>
            <td>
              <div class="flex gap-2">
                <!-- View Charges - DESHABILITADO TEMPORALMENTE -->
                <p-button
                  (onClick)="onViewCharges(entry)"
                  [raised]="true"
                  [disabled]="true"
                  icon="pi pi-dollar"
                  [pTooltip]="'checkOutTable.actions.viewChargesSoon' | translate"
                  severity="info"
                  size="small"
                  tooltipPosition="top"
                  variant="outlined"
                />
                <!-- Process Check-out -->
                @if (entry.status === 'pending') {
                  <p-button
                    (onClick)="onProcessCheckOut(entry)"
                    [raised]="true"
                    icon="pi pi-sign-out"
                    [pTooltip]="'checkOutTable.actions.processCheckOut' | translate"
                    severity="success"
                    size="small"
                    tooltipPosition="top"
                    variant="outlined"
                  />
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="text-center p-4" colspan="10">
              <div class="text-gray-500 dark:text-gray-400">
                {{ 'checkOutTable.emptyPending' | translate }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
